export default __webpack_public_path__ + "static/media/Declaration of Independence_14.396a3001.jpg";